import { createSlice } from '@reduxjs/toolkit'

export const employeeSlicer = createSlice({
  name: 'addedJob',
  initialState: {
    arr: {}
  },
  reducers: {

    add: (state, action) => {
          state.arr = action.payload; 
    },
  },
})

// Action creators are generated for each case reducer function
export const { add } = employeeSlicer.actions

export default employeeSlicer.reducer